import React from "react";
import Price from "./index";
import * as styles from "./product-price.scss";
function CampaingPrice(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(Price, Object.assign({ className: styles.campaignPrice }, props.variant.price, { 
            //eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            //@ts-ignore
            microData: true, size: "huge", id: props.variant.code })),
        React.createElement(Price
        //eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        //@ts-ignore
        , { 
            //eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            //@ts-ignore
            className: styles.strikethrough, current: props.variant.price.original, priceUnit: props.variant.price.priceUnit, currencySymbol: props.variant.price.currencySymbol, size: "large", microData: false })));
}
function RegularPrice(props) {
    return (React.createElement(Price, Object.assign({}, props.variant.price, { 
        //eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        //@ts-ignore
        size: "large", microData: true, id: props.variant.code })));
}
export function RenderPrice(props) {
    const { productIsInCampaign, variant } = props;
    const isCampaign = productIsInCampaign &&
        variant.price &&
        variant.price.current < variant.price.original;
    return isCampaign ? (React.createElement(CampaingPrice, { variant: variant })) : (React.createElement(RegularPrice, { variant: variant }));
}
export default function ProductPrice(props) {
    const { selectedVariant, productIsInCampaign, isWeightProduct, allVariants } = props;
    return props.hide ? null : (React.createElement(React.Fragment, null, isWeightProduct ? (allVariants.map((v) => (React.createElement("div", { key: v.code, className: styles.priceItem },
        React.createElement(RenderPrice, { variant: v, productIsInCampaign: productIsInCampaign }))))) : (React.createElement(RenderPrice, { variant: selectedVariant, productIsInCampaign: productIsInCampaign }))));
}
